import { Box, Typography } from '@material-ui/core';
import type { ReactNode } from 'react';

export const AccessPageIntro = ({ children }: { children: ReactNode }) => (
  <Box mb={2}>
    <Typography color="textSecondary" variant="body2">
      {children}
    </Typography>
  </Box>
);
